module.exports = {
  render: function (lockedLibrary) {
    var restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    var can = restrictionsFacade.isFunctionalityAllowed;

    this.lockedLibrary = lockedLibrary;
    this.$el.html(this.template({
      class: this.class,
      buttons: this.buttons.filter(buttonFilter)
    }));

    this.helperView && this.helperView.remove();
    lockedLibrary && this.initHelper();

    function buttonFilter (button) {
      if (button.disabled) return false;

      switch (button.key) {
        case 'image': return can('function_use_own_images') && can('image_add');
        case 'text': return can('text_add');
        case 'icon': return can('vector_add');
      }

      return true;
    }
  }
};
